import { ElementSource } from "chq";
import { GENERIC_ELEMENT } from "components/stories/video-studio/utils/constants";

const findGenericElementByName = (
  elements: ElementSource[] | undefined,
  name: typeof GENERIC_ELEMENT[keyof typeof GENERIC_ELEMENT]
): ElementSource[] => {
  const lowerCaseName = name.toLowerCase();
  return elements?.filter(element => {
    const elementName = element.name || "";
    return elementName.toLowerCase().includes(lowerCaseName);
  }) || [];
};

// find all the elements at once
export const findAllGenericElements = (elements: ElementSource[] | undefined) => ({
  storyElement: findGenericElementByName(elements, GENERIC_ELEMENT.STORY),
  introElement: findGenericElementByName(elements, GENERIC_ELEMENT.INTRO),
  outroElement: findGenericElementByName(elements, GENERIC_ELEMENT.OUTRO),
  nameAndTitleElement: findGenericElementByName(elements, GENERIC_ELEMENT.NAME_TITLE),
  promptElement: findGenericElementByName(elements, GENERIC_ELEMENT.PROMPT),
  trendElement: findGenericElementByName(elements, GENERIC_ELEMENT.TREND),
  captionElement: findGenericElementByName(elements, GENERIC_ELEMENT.CAPTION),
  logoElement: findGenericElementByName(elements, GENERIC_ELEMENT.COMPANY_LOGO),
  creatorFirstNameElement: findGenericElementByName(elements, GENERIC_ELEMENT.CREATOR_FIRST_NAME),
  creatorLastnameElement: findGenericElementByName(elements, GENERIC_ELEMENT.CREATOR_LAST_NAME),
  creatorFullpromptElement: findGenericElementByName(elements, GENERIC_ELEMENT.CREATOR_FULL_NAME),
  creatorNameElement: findGenericElementByName(elements, GENERIC_ELEMENT.CREATOR_NAME),
  creatorTitleElement: findGenericElementByName(elements, GENERIC_ELEMENT.CREATOR_TITLE),
  creatorDeparmentElement: findGenericElementByName(elements, GENERIC_ELEMENT.CREATOR_DEPARTMENT),
  creatorProfessionElement: findGenericElementByName(elements, GENERIC_ELEMENT.CREATOR_PROFESSION),
  creatorLocationElement: findGenericElementByName(elements, GENERIC_ELEMENT.CREATOR_LOCATION),
  creatorBusinessElement: findGenericElementByName(elements, GENERIC_ELEMENT.CREATOR_BUSINESS),
  creatorProfileImageElement: findGenericElementByName(
    elements, GENERIC_ELEMENT.CREATOR_PROFILE_IMAGE
  )
});

export default findGenericElementByName;
